import React, { useState, useEffect } from 'react';
//imports core
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import Chat from "@material-ui/icons/Chat";
import ReceiptIcon from '@material-ui/icons/Receipt';
import ModalValidateSell from "components/ModalValidateSell/ModalValidateSell";
import ModalAddCommentStorage from "components/ModalAddCommentStorage/ModalAddCommentStorage.js";
import ModalValidateAllSell from "components/ModalValidateAllSell/ModalValidateAllSell"
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import { formatDateFilter, formatDate } from "services/formatDate.js";
import useAuth from "hooks/useAuth";
import api from 'assets/services/api';
//imports material
import Done from "@material-ui/icons/Done";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    acctAll: {
        float: "right",
        marginTop: "-29px",
    },
    floatRight: {
        float: "right",
        marginRight: "35px"
    }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function TableSellOperator({ sell, loadTotal, loadSell, toogle }) {


    const classes = useStyles();
    const classes2 = useStyles2();
    const { storageId } = useAuth();

    const [modalShow, setModalShow] = useState(false);
    const [modalAllShow, setModalAllShow] = useState(false);
    const [modalMessageShow, setModalMessageShow] = useState(false);
    const [index, setIndex] = useState({ id: 1 });
    const [indexMessage, setIndexMessage] = useState({ id: 1 });
    const [totalPrice2, setTotalPrice2] = useState(0);
    const [loading, setLoading] = useState(false);

    function callModal(index) {
        setIndex(index);
        setModalShow(true);
    }

    function callModal(index) {
        setIndex(index);
        setModalShow(true);
    }

    function callModalMessage(index) {
        setIndexMessage(index);
        setModalMessageShow(true);
    }

    function callModalValidateAll(index) {
        setIndex(index);
        setModalAllShow(true);
    }
    async function openReceipt(sell) {
        //  let link = "http://acesso.ctrcsistema.com.br:7000/CTRCSISTEMA/rastreamento2recibo.jsp?company=LIGA&cnpjcpf=01685851000188&p=123&db=LIGA&" + sell[0].receipt;
        let link2 = "https://api.dsaprospectos.com.br/image/" + sell[0].nf;

        if (sell[0].receipt) {
            //    window.open(link, "_blank")
        } else {
            window.open(link2, "_blank")
        }
    };

    async function generateOrderStatement(nf, client) {
        setLoading(true);
        const response = await api.post('/sell/generate/statement/pdf', {
            id: storageId,
            data: [{ nf: nf }],
            type: "sell",
            userType: 'operator'
        }, {
            responseType: "blob", // Definido aqui
        }).then(async function (response) {
            let blob = new Blob([response.data], {
                responseType: "arraybuffer",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/pdf",
                },
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `Venda_${client} - ${nf}.pdf`;
            link.click();
        }).catch(function (error) {
            console.log(error);
        });
        setLoading(false);
    };

    function totalPrice(index) {
        let total = 0;
        for (let i = 0; i < index.length; i++) {
            total = parseFloat(total) + parseFloat(index[i].price_total);
        }
        setTotalPrice2(total)
    }

    useEffect(() => {
        totalPrice(sell);
    }, [sell])

    function getNf() {

        let teste = [];
        for (let i = 0; i < sell.length; i++) {
            teste[i] = [];
            teste[i].push(sell[i].nf)
            teste[i].push(sell[i].fantasy_name)
            if (sell[i].id_product === 27 || sell[i].id_product === 49) {
                teste[i].push(sell[i].weight)
                teste[i].push((sell[i].weight / sell[i].box))
            } else {
                teste[i].push(sell[i].amount)
                teste[i].push((sell[i].amount / sell[i].box))
            }
            teste[i].push(sell[i].name)
            teste[i].push("R$" + sell[i].practice_price)
            teste[i].push("R$" + sell[i].discount)
            teste[i].push("R$" + sell[i].price_total)
            teste[i].push(formatDate(sell[i].date_of_sell))
            teste[i].push(
                <CardIcon>
                    <Icon title={sell[i].validated ? "Validado" : "Não validado"}>{sell[i].validated ? "done" : "clear"}</Icon>
                </CardIcon>
            )
            teste[i].push(
                sell[i].date_of_delivery ? formatDate(sell[i].date_of_delivery) : "Não entregue"
            )
            teste[i].push(
                sell[i].deliverymanname ? sell[i].deliverymanname : "Não entregue"
            )
            teste[i].push(
                <div className={classes2.tableActions}>
                    {(!sell[i].validated && storageId !== 6) ?
                        <Tooltip
                            id="tooltip-top"
                            title="Validar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Done"
                                className={classes2.tableActionButton}
                                onClick={() => callModal(sell[i])}
                            >
                                <Done
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.edit
                                    }

                                />
                            </IconButton>

                        </Tooltip>
                        : <div />
                    }
                    <Tooltip
                        id="tooltip-top"
                        title="Reportar erro"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Chat"
                            className={classes2.tableActionButton}
                            onClick={() => callModalMessage(sell[i])}
                        >
                            <Chat
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit
                                }

                            />
                        </IconButton>

                    </Tooltip>
                </div>
            )
        }
        return teste;
    }

    return (
        <GridItem xs={12} sm={12} md={12}>
            {sell[0] !== undefined ? (
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader className={classes.zindex} color={sell[0].remove_in_hands ? "primary" : (sell[0].cancelled) ? "warning" : (sell[0].validated ? "success" : "danger")}>
                            <h4 className={classes.cardTitleWhite}>
                                {sell[0].validated ?
                                    <Tooltip
                                        id="tooltip-top"
                                        title={"Recibo"}
                                        placement="top"
                                        classes={{ tooltip: classes2.tooltip }}
                                    >
                                        <IconButton
                                            aria-label="Done"
                                            className={classes2.tableActionButton}
                                            onClick={() => openReceipt(sell)}
                                        >
                                            <ReceiptIcon
                                                className={
                                                    classes2.tableActionButtonIcon + " " + classes2.edit2
                                                }
                                            />
                                        </IconButton>
                                    </Tooltip>
                                    : <div></div>}
                                Vendas - {sell[0].social_reason} - Vendas - {sell[0].social_reason} - <Button variant="outlined"
                                    onClick={() => { generateOrderStatement(sell[0].nf, sell[0].social_reason) }}
                                    style={{
                                        borderColor: 'white',
                                        borderWidth: '3px',
                                        color: 'white',
                                        fontSize: '17px'
                                    }}>
                                    {sell[0].nf}
                                </Button>
                                <b className={classes.floatRight}> Total: R$ {totalPrice2.toFixed(2)}</b></h4>
                            {(!toogle && storageId !== 6) ?
                                <div className={classes.acctAll}>
                                    <Tooltip
                                        id="tooltip-top"
                                        title="Validar todos"
                                        placement="top"
                                        classes={{ tooltip: classes2.tooltip }}
                                    >
                                        <IconButton
                                            aria-label="Done"
                                            className={classes2.tableActionButton}
                                            onClick={() => callModalValidateAll(sell[0])}
                                        >
                                            <Done
                                                className={
                                                    classes2.tableActionButtonIcon + " " + classes2.edit2
                                                }
                                            />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                : <div></div>}
                            <p className={classes.cardCategoryWhite}></p>
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="danger"
                                index={index}
                                tableHead={["Nota Fiscal", "Cliente", "Quantidade", "Quantidade em caixa", "Produto", "Preço praticado", "Desconto", "Preço total", "Data da venda", "Status", "Data da entrega", "Entregador", "Ações"]}
                                tableData={getNf()}
                            />
                        </CardBody>
                    </Card>
                    <ModalValidateSell key={String(index.id)} props={index} loadSell={loadSell} loadTotal={loadTotal} show={modalShow}
                        onHide={() => setModalShow(false)} />
                    <ModalAddCommentStorage key={indexMessage.id} props={indexMessage} type={"sell"} show={modalMessageShow}
                        onHide={() => setModalMessageShow(false)} />
                    <ModalValidateAllSell key={String("ValAll_" + index.nf)} props={index} loadSell={loadSell} loadTotal={loadTotal} show={modalAllShow} onHide={() => setModalAllShow(false)} type="vendas" />
                </GridItem >
            ) : <div></div>}
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
                onClick={() => { }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </GridItem>
    );
}

export default TableSellOperator;